import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=6c94533a&"
import script from "./DocumentEditor.vue?vue&type=script&lang=js&"
export * from "./DocumentEditor.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=6c94533a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports